export const TargetFileExtension = 'fltar';
export const TocFileExtension = 'fltoc';
export const SnippetFileExtension = 'flsnp';
export const TemplatePageFileExtension = 'flmsp';
